<div class="endorsement-remaining">
  <div class="endorsement-remaining__header">
    <div class="title">An action was missed</div>
  </div>
  <div class="endorsement-remaining__body">
    <p>
      Looks like a signature or other action wasn't applied to this document. 
      If this was on purpose select "Continue" to move to the next document, otherwise select "Back" to return to the current document.
    </p>
  </div>

  <app-button-container>
    <app-button type="secondary" [dataTestId]="'endorsement-remaining-back'" (buttonClick)="backClick()">Back</app-button>
    <app-button type="warning" [dataTestId]="'endorsement-remaining-continue'" (buttonClick)="continueClick()">Continue</app-button>
  </app-button-container>
</div>
